import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BEMHelper from 'react-bem-helper';
import PropTypes from 'prop-types';
import './style.onetrust-entry.less';

const classes = new BEMHelper('onetrust-entry');

const OneTrustEntry = ({ children, className, text }) => {
    const [visible, setVisible] = useState(() => !!window.OneTrust);

    const handleClickCookiePreferences = useCallback(e => {
        e.preventDefault();
        window.OneTrust?.ToggleInfoDisplay();
    }, []);

    const showEntry = useCallback(() => setVisible(true), [setVisible]);

    useEffect(() => {
        if (!visible) {
            window.addEventListener('OneTrustLoaded', showEntry);

            return () => {
                window.removeEventListener('OneTrustLoaded', showEntry);
            };
        }
    }, [visible, showEntry]);

    const Entry = useMemo(
        () => (
            <a
                {...classes({ extra: className })}
                onClick={handleClickCookiePreferences}
                role='button'>
                {text}
            </a>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [handleClickCookiePreferences, text]
    );

    return visible && (typeof children === 'function' ? children(Entry) : Entry);
};

OneTrustEntry.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
};

export default OneTrustEntry;
